const translation = {
  currentPlan: 'Aktueller Tarif',
  upgradeBtn: {
    plain: 'Tarif Upgraden',
    encourage: 'Jetzt Upgraden',
    encourageShort: 'Upgraden',
  },
  viewBilling: 'Abrechnung und Abonnements verwalten',
  buyPermissionDeniedTip: 'Bitte kontaktieren Sie Ihren Unternehmensadministrator, um zu abonnieren',
  plansCommon: {
    title: 'Wählen Sie einen Tarif, der zu Ihnen passt',
    yearlyTip: 'Erhalten Sie 2 Monate kostenlos durch jährliches Abonnieren!',
    mostPopular: 'Am beliebtesten',
    planRange: {
      monthly: 'Monatlich',
      yearly: 'Jährlich',
    },
    month: 'Monat',
    year: 'Jahr',
    save: 'Sparen ',
    free: 'Kostenlos',
    currentPlan: 'Aktueller Tarif',
    contractSales: 'Vertrieb kontaktieren',
    contractOwner: 'Teammanager kontaktieren',
    startForFree: 'Kostenlos starten',
    getStartedWith: 'Beginnen Sie mit ',
    contactSales: 'Vertrieb kontaktieren',
    talkToSales: 'Mit dem Vertrieb sprechen',
    modelProviders: 'Modellanbieter',
    teamMembers: 'Teammitglieder',
    buildApps: 'Apps bauen',
    vectorSpace: 'Vektorraum',
    vectorSpaceBillingTooltip: 'Jedes 1MB kann ungefähr 1,2 Millionen Zeichen an vektorisierten Daten speichern (geschätzt mit OpenAI Embeddings, variiert je nach Modell).',
    vectorSpaceTooltip: 'Vektorraum ist das Langzeitspeichersystem, das erforderlich ist, damit LLMs Ihre Daten verstehen können.',
    documentsUploadQuota: 'Dokumenten-Upload-Kontingent',
    documentProcessingPriority: 'Priorität der Dokumentenverarbeitung',
    documentProcessingPriorityTip: 'Für eine höhere Dokumentenverarbeitungspriorität, bitte Ihren Tarif upgraden.',
    documentProcessingPriorityUpgrade: 'Mehr Daten mit höherer Genauigkeit bei schnelleren Geschwindigkeiten verarbeiten.',
    priority: {
      'standard': 'Standard',
      'priority': 'Priorität',
      'top-priority': 'Höchste Priorität',
    },
    logsHistory: 'Protokollverlauf',
    customTools: 'Benutzerdefinierte Werkzeuge',
    unavailable: 'Nicht verfügbar',
    days: 'Tage',
    unlimited: 'Unbegrenzt',
    support: 'Support',
    supportItems: {
      communityForums: 'Community-Foren',
      emailSupport: 'E-Mail-Support',
      priorityEmail: 'Priorisierter E-Mail- und Chat-Support',
      logoChange: 'Logo-Änderung',
      SSOAuthentication: 'SSO-Authentifizierung',
      personalizedSupport: 'Persönlicher Support',
      dedicatedAPISupport: 'Dedizierter API-Support',
      customIntegration: 'Benutzerdefinierte Integration und Support',
      ragAPIRequest: 'RAG-API-Anfragen',
      bulkUpload: 'Massenupload von Dokumenten',
      agentMode: 'Agentenmodus',
      workflow: 'Workflow',
      llmLoadingBalancing: 'LLM-Lastausgleich',
      llmLoadingBalancingTooltip: 'Fügen Sie Modellen mehrere API-Schlüssel hinzu, um die API-Ratenlimits effektiv zu umgehen.',
    },
    comingSoon: 'Demnächst',
    member: 'Mitglied',
    memberAfter: 'Mitglied',
    messageRequest: {
      title: 'Nachrichtenguthaben',
      tooltip: 'Nachrichtenaufrufkontingente für verschiedene Tarife unter Verwendung von OpenAI-Modellen (außer gpt4).Nachrichten über dem Limit verwenden Ihren OpenAI-API-Schlüssel.',
      titlePerMonth: '{{count,number}} Nachrichten/Monat',
    },
    annotatedResponse: {
      title: 'Kontingentgrenzen für Annotationen',
      tooltip: 'Manuelle Bearbeitung und Annotation von Antworten bieten anpassbare, hochwertige Frage-Antwort-Fähigkeiten für Apps. (Nur anwendbar in Chat-Apps)',
    },
    ragAPIRequestTooltip: 'Bezieht sich auf die Anzahl der API-Aufrufe, die nur die Wissensdatenbankverarbeitungsfähigkeiten von Dify aufrufen.',
    receiptInfo: 'Nur der Teaminhaber und der Teamadministrator können abonnieren und Abrechnungsinformationen einsehen',
    annotationQuota: 'Kontingent für Anmerkungen',
    unlimitedApiRate: 'Keine API-Ratebeschränkung',
    teamMember_other: '{{count,number}} Teammitglieder',
    priceTip: 'pro Arbeitsbereich/',
    teamWorkspace: '{{count,number}} Team Arbeitsplatz',
    annualBilling: 'Jährliche Abrechnung',
    self: 'Selbst gehostet',
    freeTrialTipPrefix: 'Melden Sie sich an und erhalten Sie ein',
    cloud: 'Cloud-Dienst',
    apiRateLimitTooltip: 'Die API-Datenbeschränkung gilt für alle Anfragen, die über die Dify-API gemacht werden, einschließlich Textgenerierung, Chat-Konversationen, Workflow-Ausführungen und Dokumentenverarbeitung.',
    getStarted: 'Loslegen',
    apiRateLimitUnit: '{{count,number}}/Tag',
    documentsTooltip: 'Vorgabe für die Anzahl der Dokumente, die aus der Wissensdatenquelle importiert werden.',
    apiRateLimit: 'API-Datenlimit',
    documents: '{{count,number}} Wissensdokumente',
    comparePlanAndFeatures: 'Pläne und Funktionen vergleichen',
    freeTrialTipSuffix: 'Keine Kreditkarte erforderlich',
    freeTrialTip: 'kostenlose Testversion von 200 OpenAI-Anfragen.',
    documentsRequestQuota: '{{count,number}}/min Wissensanforderungsratenlimit',
    teamMember_one: '{{count,number}} Teammitglied',
    documentsRequestQuotaTooltip: 'Gibt die Gesamtzahl der Aktionen an, die ein Arbeitsbereich pro Minute innerhalb der Wissensbasis ausführen kann, einschließlich der Erstellung, Löschung, Aktualisierung von Datensätzen, des Hochladens von Dokumenten, von Änderungen, der Archivierung und von Abfragen in der Wissensbasis. Diese Kennzahl wird verwendet, um die Leistung von Anfragen an die Wissensbasis zu bewerten. Wenn ein Sandbox-Nutzer beispielsweise in einer Minute 10 aufeinanderfolgende Testdurchläufe durchführt, wird sein Arbeitsbereich für die nächste Minute vorübergehend daran gehindert, die folgenden Aktionen auszuführen: Erstellung, Löschung, Aktualisierung von Datensätzen sowie das Hochladen oder Ändern von Dokumenten.',
  },
  plans: {
    sandbox: {
      name: 'Sandbox',
      description: '200 mal GPT kostenlos testen',
      includesTitle: 'Beinhaltet:',
      for: 'Kostenlose Testversion der Kernfunktionen',
    },
    professional: {
      name: 'Professionell',
      description: 'Für Einzelpersonen und kleine Teams, um mehr Leistung erschwinglich freizuschalten.',
      includesTitle: 'Alles im kostenlosen Tarif, plus:',
      for: 'Für unabhängige Entwickler/kleine Teams',
    },
    team: {
      name: 'Team',
      description: 'Zusammenarbeiten ohne Grenzen und Top-Leistung genießen.',
      includesTitle: 'Alles im Professionell-Tarif, plus:',
      for: 'Für mittelgroße Teams',
    },
    enterprise: {
      name: 'Unternehmen',
      description: 'Erhalten Sie volle Fähigkeiten und Unterstützung für großangelegte, missionskritische Systeme.',
      includesTitle: 'Alles im Team-Tarif, plus:',
      features: {
        2: 'Exklusive Unternehmensfunktionen',
        8: 'Professioneller technischer Support',
        6: 'Erweiterte Sicherheits- und Kontrollsysteme',
        4: 'SSO',
        0: 'Enterprise-Grade Skalierbare Bereitstellungslösungen',
        3: 'Mehrere Arbeitsbereiche und Unternehmensverwaltung',
        1: 'Kommerzielle Lizenzgenehmigung',
        5: 'Verhandelte SLAs durch Dify-Partner',
        7: 'Updates und Wartung von Dify offiziell',
      },
      btnText: 'Vertrieb kontaktieren',
      price: 'Benutzerdefiniert',
      priceTip: 'Jährliche Abrechnung nur',
      for: 'Für große Teams',
    },
    community: {
      features: {
        2: 'Entspricht der Dify Open Source Lizenz',
        1: 'Einzelner Arbeitsbereich',
        0: 'Alle Kernfunktionen wurden im öffentlichen Repository veröffentlicht.',
      },
      description: 'Für Einzelbenutzer, kleine Teams oder nicht-kommerzielle Projekte',
      for: 'Für Einzelbenutzer, kleine Teams oder nicht-kommerzielle Projekte',
      btnText: 'Beginnen Sie mit der Gemeinschaft',
      price: 'Kostenlos',
      includesTitle: 'Kostenlose Funktionen:',
      name: 'Gemeinschaft',
    },
    premium: {
      features: {
        2: 'WebApp-Logo und Branding-Anpassung',
        0: 'Selbstverwaltete Zuverlässigkeit durch verschiedene Cloud-Anbieter',
        3: 'Priorisierte E-Mail- und Chat-Unterstützung',
        1: 'Einzelner Arbeitsbereich',
      },
      includesTitle: 'Alles aus der Community, plus:',
      name: 'Premium',
      priceTip: 'Basierend auf dem Cloud-Marktplatz',
      for: 'Für mittelgroße Organisationen und Teams',
      btnText: 'Jetzt Premium erhalten in',
      comingSoon: 'Microsoft Azure- und Google Cloud-Support demnächst verfügbar',
      description: 'Für mittelgroße Organisationen und Teams',
      price: 'Skalierbar',
    },
  },
  vectorSpace: {
    fullTip: 'Vektorraum ist voll.',
    fullSolution: 'Upgraden Sie Ihren Tarif, um mehr Speicherplatz zu erhalten.',
  },
  apps: {
    fullTipLine1: 'Upgraden Sie Ihren Tarif, um',
    fullTipLine2: 'mehr Apps zu bauen.',
    contactUs: 'Kontaktieren Sie uns',
    fullTip1: 'Upgrade, um mehr Apps zu erstellen',
    fullTip2des: 'Es wird empfohlen, inaktive Anwendungen zu bereinigen, um Speicherplatz freizugeben, oder uns zu kontaktieren.',
    fullTip1des: 'Sie haben das Limit für das Erstellen von Apps in diesem Plan erreicht.',
    fullTip2: 'Limit erreicht',
  },
  annotatedResponse: {
    fullTipLine1: 'Upgraden Sie Ihren Tarif, um',
    fullTipLine2: 'mehr Konversationen zu annotieren.',
    quotaTitle: 'Kontingent für Annotation-Antworten',
  },
  usagePage: {
    buildApps: 'Apps erstellen',
    annotationQuota: 'Annotierungsquote',
    teamMembers: 'Teammitglieder',
    documentsUploadQuota: 'Dokumenten-Upload-Quota',
    vectorSpace: 'Wissensdatenbank',
    vectorSpaceTooltip: 'Dokumente mit dem Hochqualitäts-Indexierungsmodus verbrauchen Ressourcen des Knowledge Data Storage. Wenn der Knowledge Data Storage die Grenze erreicht, werden keine neuen Dokumente hochgeladen.',
  },
  teamMembers: 'Teammitglieder',
}

export default translation
